import type { useHoverCard } from "#hooks/useHoverCard.ts";
import { PopoverBase } from "@hopper-ui/components";
import classNames from "classnames";
import type { ReactNode, RefObject } from "react";
import "./HoverCard.css";
import "./HoverCard.dark.css";

type HoverCardState = ReturnType<typeof useHoverCard>;

interface Props {
    triggerRef: RefObject<HTMLElement | null>;
    cardRef: RefObject<HTMLElement | null>;
    cardId: string;
    label?: string;
    /** Sizes the card for its content; the surface, type and motion are the card's own. */
    className?: string;
    /** Keeps the card, its label included, out of session recordings, for a card about a person. */
    isPrivate?: boolean;
    popoverProps: HoverCardState["popoverProps"];
    cardProps: HoverCardState["cardProps"];
    children: ReactNode;
}

/** The card a trigger opens on hover or keyboard focus (see useHoverCard): the prototype's tooltip, 6px above it. */
export const HoverCard = ({ triggerRef, cardRef, cardId, label, className, isPrivate = false, popoverProps, cardProps, children }: Props) => (
    <PopoverBase
        ref={cardRef}
        triggerRef={triggerRef}
        isNonModal
        placement="top"
        offset={6}
        containerPadding={0}
        className={classNames("wai-hover-card", className)}
        {...popoverProps}
    >
        <div id={cardId} role="dialog" aria-label={label || undefined} data-private={isPrivate ? "" : undefined} {...cardProps}>
            {children}
        </div>
    </PopoverBase>
);
